import { parse, stringify } from 'Libs/qs';
import { createBrowserHistory } from 'history';

function preserveQueryParameters(history, preserve, location) {
  const currentQuery = parse(history.location.search);
  if (currentQuery) {
    const preservedQuery = {};
    for (let p of preserve) {
      const v = currentQuery[p];
      if (v) {
        preservedQuery[p] = v;
      }
    }
    if (location.search) {
      Object.assign(preservedQuery, parse(location.search));
    }
    location.search = stringify(preservedQuery);
  }
  return location;
}

function createLocationDescriptorObject(location, state) {
  return typeof location === 'string'
    ? { pathname: location, state }
    : location;
}

function createPreserveQueryHistory(createHistory, queryParameters) {
 
  return options => {
    const history = createHistory(options);
 
    return history;
  };
}

export default createPreserveQueryHistory(createBrowserHistory, [
  'id',
  'pending'
])();
